import React, { useRef } from 'react'
import styles from './Voice.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  contents: {
    title: string
    items: {
      num: string
      itemTitle: string | JSX.Element
      industry: string
      description: string | JSX.Element
    }[]
  }
}

const Voice: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.voice} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.voice__title}>{contents.title}</h2>
        <div className={styles.voiceBox}>
          {contents.items.map((item, i) => (
            <div className={styles.voiceBox__item} key={i}>
              <div className={styles.voiceBox__item__box}>
                <span className={styles.voiceBox__item__box__text}>VOICE</span>
                <span className={styles.voiceBox__item__box__num}>{item.num}</span>
              </div>
              <div className={styles.voiceBox__item__wrapper}>
                <h3 className={styles.voiceBox__item__wrapper__title}>{item.itemTitle}</h3>
                <p className={styles.voiceBox__item__wrapper__industry}>
                  <span>業種</span>
                  {item.industry}
                </p>
                <p className={styles.voiceBox__item__wrapper__text}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default Voice
